import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError,map } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { BaseAPIService } from "../baseapi/baseapiservice";
import { ProvisionItemDescription } from "../../models/provisionitemdescription";
import { ProvisionItem } from "../../models/provisionitem";
import { HttpClient } from '@angular/common/http';
import { ProvisionItemDescriptionMap } from 'src/models/provisionitemdescriptionmap';

@Injectable()
export class SpecItemDescriptionService extends BaseAPIService {

    ProvisionItemDescriptions: Array<ProvisionItemDescription>;

    constructor(private http: HttpClient) {
        // call the BaseAPIService constructor
        super();
    }

    getProvisionItemFamilyAndExecutionDescription(Specification: Array<ProvisionItem>): Observable<ProvisionItemDescriptionMap>{
        return this.http.post<Array<ProvisionItemDescription>>(environment.baseurl + 'Workshop/SpecificationitemFamilyAndExecutionDescriptions', Specification).pipe(
                map(response => ProvisionItemDescription.toMap(response)),
                catchError(this.handleError)
            );
    }
}